import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { OrderFormPage } from './pages/OrderFormPage';
import { OrderDashboardPage } from './pages/OrderDashboardPage';
import { Agency } from './types';
type Screen = 'order-form' | 'dashboard';
export function App() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('order-form');
  const [selectedAgency, setSelectedAgency] = useState<Agency | null>(null);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const handleOrderSubmitted = (agency: Agency) => {
    setSelectedAgency(agency);
    setCurrentScreen('dashboard');
  };
  const handleNavigate = (screen: Screen) => {
    setCurrentScreen(screen);
  };
  return <div className="flex h-screen w-full bg-slate-50 font-sans text-slate-900 overflow-hidden" data-id="element-0">
      {/* Left Sidebar Navigation */}
      <Sidebar isCollapsed={isSidebarCollapsed} onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)} onNavigate={handleNavigate} currentScreen={currentScreen} data-id="element-1" />

      {/* Main Content Area */}
      <main className="flex-1 flex flex-col h-full overflow-hidden relative" data-id="element-2">
        {currentScreen === 'order-form' && <OrderFormPage onSubmit={handleOrderSubmitted} data-id="element-3" />}

        {currentScreen === 'dashboard' && selectedAgency && <OrderDashboardPage agency={selectedAgency} data-id="element-4" />}
      </main>
    </div>;
}